var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockCountdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1000_582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6666 21.25C35.0307 28.95 28.5307 35 20.6666 35C16.6884 35 12.8731 33.4196 10.06 30.6066C7.24698 27.7936 5.66663 23.9782 5.66663 20C5.66663 12.1359 11.7166 5.63594 19.4166 5",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 11.25V20H29.4166",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6666 7.1875C26.5296 7.1875 27.2291 6.48794 27.2291 5.625C27.2291 4.76206 26.5296 4.0625 25.6666 4.0625C24.8037 4.0625 24.1041 4.76206 24.1041 5.625C24.1041 6.48794 24.8037 7.1875 25.6666 7.1875Z",
    fill: "#051B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2916 10.9375C32.1546 10.9375 32.8541 10.2379 32.8541 9.375C32.8541 8.51206 32.1546 7.8125 31.2916 7.8125C30.4287 7.8125 29.7291 8.51206 29.7291 9.375C29.7291 10.2379 30.4287 10.9375 31.2916 10.9375Z",
    fill: "#051B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0416 16.5625C35.9046 16.5625 36.6041 15.8629 36.6041 15C36.6041 14.1371 35.9046 13.4375 35.0416 13.4375C34.1787 13.4375 33.4791 14.1371 33.4791 15C33.4791 15.8629 34.1787 16.5625 35.0416 16.5625Z",
    fill: "#051B46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1000_582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.666626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockCountdown);
export default __webpack_public_path__ + "static/media/ClockCountdown.6c00fa20928fabce01759846fd3ff046.svg";
export { ForwardRef as ReactComponent };